var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6525 7.0132C10.5113 8.34589 11.6533 9.47974 13.0011 10.3306L7.52261 15.8101C7.09765 16.235 6.88524 16.4477 6.62418 16.5874C6.3631 16.7271 6.06806 16.7859 5.47867 16.9038L3.2355 17.353C2.90289 17.4196 2.73636 17.4525 2.64175 17.3579C2.54725 17.2633 2.58014 17.0967 2.64664 16.7642L3.09586 14.521C3.21374 13.9316 3.27253 13.6366 3.41226 13.3755C3.55198 13.1144 3.76464 12.902 4.18961 12.4771L9.6525 7.0132ZM12.964 3.73C13.6761 3.19418 14.6572 3.19416 15.3693 3.73C15.4815 3.81443 15.5987 3.93207 15.8332 4.16652C16.0677 4.40102 16.1852 4.51818 16.2697 4.63039C16.8057 5.34251 16.8055 6.32347 16.2697 7.03566C16.1852 7.14784 16.0676 7.2651 15.8332 7.49953L14.4582 8.87355C13.0593 8.08742 11.9033 6.93932 11.1066 5.5591L12.5002 4.16652C12.7346 3.93209 12.8518 3.81443 12.964 3.73Z",
    fill: "#9061DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditFill);
export default __webpack_public_path__ + "static/media/Edit_fill.9c431fc9c54cc2e0a5b588356c2b4ad9.svg";
export { ForwardRef as ReactComponent };